const productApi = {
	get: (id) => window.evrythngToken.product(id),
};

export default productApi;
